import axios from 'axios'
import { GET_MAKER_ID } from './getPost'

type TModel = {
  car_model_id: string// eslint-disable-line camelcase
  car_model_name: string// eslint-disable-line camelcase
}

type TModelArray = {
  text: string
  value: string
}

type TObject = {
  line: number
  array: TModelArray[]
}
const CONVERT_DATA = (_d) => {
  const D = _d.data.car_model_array
  const parseData:TObject[] = []
  D.forEach((data, index) => {
    const o:TObject = { line: 0, array: [] }
    o.line = index + 1
    data.car_model_name_line_array.forEach((d:TModel, i) => {
      o.array.push({
        value: d.car_model_id,
        text: d.car_model_name
      })
    })
    parseData.push(o)
  })
  return parseData
}

const POST_REQ = async (STATE, _resolve, _path) => {
  const maker_id = GET_MAKER_ID(STATE.questions)// eslint-disable-line camelcase
  const SEND_DATA:any = {
    maker_id
  }
  const PARAMS = new URLSearchParams(SEND_DATA)
  const RESPONCE = await axios.post(_path, PARAMS).catch((e) => {
    _resolve(CONVERT_DATA(e.response))
  })
  RESPONCE && _resolve(CONVERT_DATA(RESPONCE))
}

export const getModel = (_state, _props, _resolve, _reject) => {
  const STATE = _state
  const PATH = process.env.END_MODEL_LIST
  POST_REQ(STATE, _resolve, PATH)
}
